import { equals, uniqBy } from 'ramda';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';

export const FRANCE_COUNTRY_VALUE = 'FRANCE';
export const RESIDENCE_COUNTRY_FIELD = 'customer.addresses.0.country';

export const isFranceCountry = equals(FRANCE_COUNTRY_VALUE);

// Sans pays renseigné -> France.
export const isForeignResidence = (country) =>
  isNotNilOrEmpty(country) && !isFranceCountry(country);

// L'indicatif est dissocié du pays de résidence :
// toujours afficher la liste complète (France + DOM-TOM + étranger), sans doublons.
export const pickPhoneIndicatives = (
  _country,
  { french = [], international = [] } = {}
) => uniqBy((item) => item.value, [...french, ...international]);
